
import { ButtonHTMLAttributes, ReactNode } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  children: ReactNode;
}

export default function Button({ 
  variant = 'primary', 
  size = 'md', 
  children, 
  className = '', 
  ...props 
}: ButtonProps) {
  const baseClasses = 'inline-flex items-center justify-center font-medium transition-all duration-150 cursor-pointer whitespace-nowrap';
  
  const variants = {
    primary: 'bg-[#2E5939] text-white hover:bg-[#2E5939]/90 hover:scale-[1.02]',
    secondary: 'bg-[#FFD84C] text-[#2B2B2B] hover:bg-[#FFD84C]/90 hover:scale-[1.02]',
    outline: 'border-2 border-[#2E5939] text-[#2E5939] hover:bg-[#2E5939] hover:text-white'
  };
  
  const sizes = {
    sm: 'px-4 py-2 text-sm rounded-full',
    md: 'px-6 py-3 text-base rounded-full',
    lg: 'px-8 py-4 text-lg rounded-full'
  };
  
  return (
    <button 
      className={`${baseClasses} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
